import { Row } from '@components/LinearLayout';

import { PSmall } from '@components/Typography';
import styled from 'styled-components';

export const EventCounterRoot = styled.div<{ $color?: string }>`
  background-color: ${({ $color, theme }) => $color ?? theme.color.transparent};
  display: flex;
  gap: 2rem;
  justify-content: start;
  width: 100%;
`;

export const EventCounterBody = styled(Row)`
  padding-left: 100px;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  height: 100%;
`;

export const AddressText = styled(PSmall)<{ padding?: string }>`
  color: ${props => props.theme.color.white};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  font-size: 16px;
  padding: ${({ padding }) => padding ?? '1rem 0 1rem 1rem'};
  white-space: nowrap;
`;

export const DateText = styled(PSmall)<{ color?: string }>`
  color: ${props => props?.color ?? props.theme.color.white};
  font-weight: ${({ theme }) => theme.fontWeight.weight500};
  font-size: 16px;
  white-space: nowrap;
`;
